module.exports = __webpack_public_path__ + "assets/map_minus.ab99c650.svg";